import React from "react";
import { ErrorBoundary } from "@rshbintech.dboul/logger";
import { Loader } from "../../../common/components/loader";
import { ErrorPage } from "../error-page";
import { ContentProps } from "../types";
import { AppLoaderProps } from "./types";

export const AppLoader = React.memo(({ children }: AppLoaderProps) => (
  <ErrorBoundary fallback={<ErrorPage />}>
    <React.Suspense fallback={<Loader />}>{children}</React.Suspense>
  </ErrorBoundary>
));

/** Account Opening */
const AccountOpeningRoutes = React.lazy(() =>
  import("account-opening-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const AccountOpeningApp = (contentProps: ContentProps) => (
  <AppLoader>
    <AccountOpeningRoutes {...contentProps} />
  </AppLoader>
);

/** Write-off registers */
const WriteOffRegistersRoutes = React.lazy(() =>
  import("write-off-registers-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const WriteOffRegistersApp = (contentProps: ContentProps) => (
  <AppLoader>
    <WriteOffRegistersRoutes {...contentProps} />
  </AppLoader>
);

/** Trustee Reports */
const TrusteeReportsRoutes = React.lazy(() =>
  import("trustee-reports-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const TrusteeReportsApp = (contentProps: ContentProps) => (
  <AppLoader>
    <TrusteeReportsRoutes {...contentProps} />
  </AppLoader>
);
/** Accreditivs */
const AccreditivsRoutes = React.lazy(() =>
  import("accreditivs-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const AccreditivsApp = (contentProps: ContentProps) => (
  <AppLoader>
    <AccreditivsRoutes {...contentProps} />
  </AppLoader>
);

/** Acquiring */
const AcquiringRoutes = React.lazy(() =>
  import("acquiring-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const AcquiringApp = (contentProps: ContentProps) => (
  <AppLoader>
    <AcquiringRoutes {...contentProps} />
  </AppLoader>
);

/** Analytics */
const AnalyticsRoutes = React.lazy(() =>
  import("analytics-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const AnalyticsApp = (contentProps: ContentProps) => (
  <AppLoader>
    <AnalyticsRoutes {...contentProps} />
  </AppLoader>
);

/** Ausn */
const AusnRoutes = React.lazy(() =>
  import("ausn-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const AusnApp = (contentProps: ContentProps) => (
  <AppLoader>
    <AusnRoutes {...contentProps} />
  </AppLoader>
);

/** Brokerage services */
const BrokerageServicesRoutes = React.lazy(() =>
  import("brokerage-services-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const BrokerageServicesApp = (contentProps: ContentProps) => (
  <AppLoader>
    <BrokerageServicesRoutes {...contentProps} />
  </AppLoader>
);

/** Cards */
const CardsRoutes = React.lazy(() =>
  import("cards-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const CardsApp = (contentProps: ContentProps) => (
  <AppLoader>
    <CardsRoutes {...contentProps} />
  </AppLoader>
);

/** Cash Management */
const CashManagementRoutes = React.lazy(() =>
  import("cash-management-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const CashManagementApp = (contentProps: ContentProps) => (
  <AppLoader>
    <CashManagementRoutes {...contentProps} />
  </AppLoader>
);

/** Cash Withdrawal */
const CashWithdrawalRoutes = React.lazy(() =>
  import("cash-withdrawal-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const CashWithdrawalApp = (contentProps: ContentProps) => (
  <AppLoader>
    <CashWithdrawalRoutes {...contentProps} />
  </AppLoader>
);

/** Contacts */
const ContactsRoutes = React.lazy(() =>
  import("crm-contacts-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const ContactsApp = (contentProps: ContentProps) => (
  <AppLoader>
    <ContactsRoutes {...contentProps} />
  </AppLoader>
);

/** Counterparties */
const CounterpartiesRoutes = React.lazy(() =>
  import("counterparties-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const CounterpartiesApp = (contentProps: ContentProps) => (
  <AppLoader>
    <CounterpartiesRoutes {...contentProps} />
  </AppLoader>
);

/** Currency Exchange */
const CurrencyExchangeRoutes = React.lazy(() =>
  import("currency-exchange-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const CurrencyExchangeApp = (contentProps: ContentProps) => (
  <AppLoader>
    <CurrencyExchangeRoutes {...contentProps} />
  </AppLoader>
);

/** Currency Trading */
const CurrencyTradingRoutes = React.lazy(() =>
  import("currency-trading-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const CurrencyTradingApp = (contentProps: ContentProps) => (
  <AppLoader>
    <CurrencyTradingRoutes {...contentProps} />
  </AppLoader>
);

/** Goods and Services */
const GoodsAndServicesRoutes = React.lazy(() =>
  import("crm-goods-and-services-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const GoodsAndServicesApp = (contentProps: ContentProps) => (
  <AppLoader>
    <GoodsAndServicesRoutes {...contentProps} />
  </AppLoader>
);

/** Calendar */
const CalendarRoutes = React.lazy(() =>
  import("crm-calendar-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const CalendarApp = (contentProps: ContentProps) => (
  <AppLoader>
    <CalendarRoutes {...contentProps} />
  </AppLoader>
);

/** Websites constructor */
const WebsitesConstructorRoutes = React.lazy(() =>
  import("crm-websites-constructor-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const WebsitesConstructorApp = (contentProps: ContentProps) => (
  <AppLoader>
    <WebsitesConstructorRoutes {...contentProps} />
  </AppLoader>
);

/** Deals */
const DealsRoutes = React.lazy(() =>
  import("crm-deals-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const DealsApp = (contentProps: ContentProps) => (
  <AppLoader>
    <DealsRoutes {...contentProps} />
  </AppLoader>
);

/** Deposits */
const DepositsRoutes = React.lazy(() =>
  import("deposits-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const DepositsApp = (contentProps: ContentProps) => (
  <AppLoader>
    <DepositsRoutes {...contentProps} />
  </AppLoader>
);

/** Promissory Notes */
const PromissoryNotesRoutes = React.lazy(() =>
  import("promissory-notes-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const PromissoryNotesApp = (contentProps: ContentProps) => (
  <AppLoader>
    <PromissoryNotesRoutes {...contentProps} />
  </AppLoader>
);

/** Foreign Activity */
const ForeignActivityRoutes = React.lazy(() =>
  import("foreign-activity-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const ForeignActivityApp = (contentProps: ContentProps) => (
  <AppLoader>
    <ForeignActivityRoutes {...contentProps} />
  </AppLoader>
);

/** Help */
const HelpRoutes = React.lazy(() =>
  import("help-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const HelpApp = (contentProps: ContentProps) => (
  <AppLoader>
    <HelpRoutes {...contentProps} />
  </AppLoader>
);

/** Invoices */
const InvoicesRoutes = React.lazy(() =>
  import("invoices-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const InvoicesApp = (contentProps: ContentProps) => (
  <AppLoader>
    <InvoicesRoutes {...contentProps} />
  </AppLoader>
);

/** Loans */
const LoansRoutes = React.lazy(() =>
  import("loans-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

/** Loans transaction */
const LoansTransactionRoutes = React.lazy(() =>
  import("loans-transaction-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const LoansTransactionApp = (contentProps: ContentProps) => (
  <AppLoader>
    <LoansTransactionRoutes {...contentProps} />
  </AppLoader>
);

/** Loyalty program */
const LoyaltyProgramRoutes = React.lazy(() =>
  import("loyalty-program-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const LoyaltyProgramApp = (contentProps: ContentProps) => (
  <AppLoader>
    <LoyaltyProgramRoutes {...contentProps} />
  </AppLoader>
);

export const LoansApp = (contentProps: ContentProps) => (
  <AppLoader>
    <LoansRoutes {...contentProps} />
  </AppLoader>
);

/** Main */
const MainRoutes = React.lazy(() =>
  import("main-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const MainApp = (contentProps: ContentProps) => (
  <AppLoader>
    <MainRoutes {...contentProps} />
  </AppLoader>
);

/** Messages */
const MessagesRoutes = React.lazy(() =>
  import("messages-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const MessagesApp = (contentProps: ContentProps) => (
  <AppLoader>
    <MessagesRoutes {...contentProps} />
  </AppLoader>
);

/** My Business */

const MyBusinessRoutes = React.lazy(() =>
  import("my-business-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const MyBusinessApp = (contentProps: ContentProps) => (
  <AppLoader>
    <MyBusinessRoutes {...contentProps} />
  </AppLoader>
);

/** Notifications */
const NotificationsRoutes = React.lazy(() =>
  import("notifications-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const NotificationsApp = (contentProps: ContentProps) => (
  <AppLoader>
    <NotificationsRoutes {...contentProps} />
  </AppLoader>
);

/** NSD Сertificate */
const NsdCertificateRoutes = React.lazy(() =>
  import("nsd-certificate-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const NsdCertificateApp = (contentProps: ContentProps) => (
  <AppLoader>
    <NsdCertificateRoutes {...contentProps} />
  </AppLoader>
);

/** Payments */
const PaymentsRoutes = React.lazy(() =>
  import("payments-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const PaymentsApp = (contentProps: ContentProps) => (
  <AppLoader>
    <PaymentsRoutes {...contentProps} />
  </AppLoader>
);

/** Profile */
const ProfileRoutes = React.lazy(() =>
  import("profile-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const ProfileApp = (contentProps: ContentProps) => (
  <AppLoader>
    <ProfileRoutes {...contentProps} />
  </AppLoader>
);

/** RCK */
const RckRoutes = React.lazy(() =>
  import("rck-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const RckApp = (contentProps: ContentProps) => (
  <AppLoader>
    <RckRoutes {...contentProps} />
  </AppLoader>
);

/** References */
const ReferencesRoutes = React.lazy(() =>
  import("references-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const ReferencesApp = (contentProps: ContentProps) => (
  <AppLoader>
    <ReferencesRoutes {...contentProps} />
  </AppLoader>
);

/** Registries */
const RegistriesRoutes = React.lazy(() =>
  import("registries-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const RegistriesApp = (contentProps: ContentProps) => (
  <AppLoader>
    <RegistriesRoutes {...contentProps} />
  </AppLoader>
);

/** Salary */
const SalaryRoutes = React.lazy(() =>
  import("salary-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const SalaryApp = (contentProps: ContentProps) => (
  <AppLoader>
    <SalaryRoutes {...contentProps} />
  </AppLoader>
);

/** Sbp */
const SbpRoutes = React.lazy(() =>
  import("sbp-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const SbpApp = (contentProps: ContentProps) => (
  <AppLoader>
    <SbpRoutes {...contentProps} />
  </AppLoader>
);

/** Showcase */
const ShowcaseRoutes = React.lazy(() =>
  import("showcase-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const ShowcaseApp = (contentProps: ContentProps) => (
  <AppLoader>
    <ShowcaseRoutes {...contentProps} />
  </AppLoader>
);

/** Statements */
const StatementsRoutes = React.lazy(() =>
  import("statements-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const StatementsApp = (contentProps: ContentProps) => (
  <AppLoader>
    <StatementsRoutes {...contentProps} />
  </AppLoader>
);

/** Tariffs */
const TariffsRoutes = React.lazy(() =>
  import("tariffs-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const TariffsApp = (contentProps: ContentProps) => (
  <AppLoader>
    <TariffsRoutes {...contentProps} />
  </AppLoader>
);

/** Transfers */
const TransfersRoutes = React.lazy(() =>
  import("transfers-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const TransfersApp = (contentProps: ContentProps) => (
  <AppLoader>
    <TransfersRoutes {...contentProps} />
  </AppLoader>
);

/** Swift messages */
const SwiftMessagesRoutes = React.lazy(() =>
  import("swift-messages-ui/routes").then((module) => ({
    default: module.AppRoutes,
  }))
);

export const SwiftMessagesApp = (contentProps: ContentProps) => (
  <AppLoader>
    <SwiftMessagesRoutes {...contentProps} />
  </AppLoader>
);
